import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PipingList } from '../MasterData/PipingListGroup/pipingListGroupSlice';
import {
  getPipingProjectDetail,
  updatePipingProjectDetail
} from '../../api/piping-project-details';

export const getPipingProjectDetailAsync = createAsyncThunk(
  'pipingProjectDetails/getPipingProjectDetail',
  getPipingProjectDetail
);

export const updatePipingProjectDetailAsync = createAsyncThunk(
  'pipingProjectDetails/updatePipingProjectDetail',
  updatePipingProjectDetail
);

export interface PipingProjectDetail {
  id: number;
  projectId: number;
  pipingWorkTypeId: number;
  pipingPlantTypeId: number | null;
  pipingModelTypeId: number | null;
  pipingLists: PipingList[];
}

interface PipingProjectDetailState {
  selectedPipingProjectDetail: PipingProjectDetail | null;
}

const initialState: PipingProjectDetailState = {
  selectedPipingProjectDetail: null
};

export default createSlice({
  name: 'pipingProjectDetails',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPipingProjectDetailAsync.fulfilled, (state, action) => {
      state.selectedPipingProjectDetail = action.payload;
    });
    builder.addCase(
      updatePipingProjectDetailAsync.fulfilled,
      (state, action) => {
        state.selectedPipingProjectDetail = action.payload;
      }
    );
  }
});
